import account from '@/api/accounts'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    account.createShopByMultiVelaeasyLogin(result => {
      if (result.data.data.publicShopKey) {
        commit('setAccountInfo', result.data.data)
      }
      resolve(result.data)
    }, param)
  })
}
